import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
//全局过滤器文件
import * as custom  from '@/filter/filter.js'
Object.keys(custom).forEach(key => {
  Vue.filter(key, custom[key])
})
Vue.use(ElementUI)

Vue.config.productionTip = false

Vue.prototype.$imgUrl='';
// Vue.prototype.$imgUrl='https://www.shxhbh.com/api/sysFileInfo/preview?id=';

// 添加全局屏幕尺寸变化监听方法
Vue.prototype.$watchScreenSize = function() {
  let lastWidth = window.innerWidth;
  let lastHeight = window.innerHeight;

  window.addEventListener('resize', () => {
    const currentWidth = window.innerWidth;
    const currentHeight = window.innerHeight;

    // 当宽度或高度发生变化时重新加载页面
    if (currentWidth !== lastWidth || currentHeight !== lastHeight) {
      lastWidth = currentWidth;
      lastHeight = currentHeight;
      window.location.reload();
    }
  });
};

new Vue({
  router,
  store,
  render: h => h(App),
  mounted () {
	  this.$store.dispatch('load')
    this.$watchScreenSize()
  }
}).$mount('#app')
